<template>
  <v-layout column>
    <v-flex
      :class="['text-center','label','p-0', {'custom-error-color': validator && validator.$error}]"
    >
      <span>{{ label }}</span>
    </v-flex>
    <v-flex>
      <v-layout justify-center align-center>
        <v-flex shrink>
          <v-btn
            slot="activator"
            :disabled="value<=minValue"
            class="size-32"
            color="primary"
            icon
            @click="decrement"
          >
            <v-icon>remove</v-icon>
          </v-btn>
        </v-flex>
        <v-flex shrink class="p-0">
          <span class="counter-value">{{ value }}</span>
        </v-flex>
        <v-flex shrink>
          <v-btn
            slot="activator"
            :disabled="value>=maxValue"
            class="size-32"
            color="primary"
            icon
            @click="increment"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-flex
        shrink
        :class="['text-center','custom-error-message', {'error--text': validator && validator.$error}]"
      >
        <span> {{ getErrors(validator)[0] }} &nbsp;</span>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import AdminContext from '@/admin-i18n/context'

import { defaultMessages, getValidationErrors } from './../../../utils'


export default {
  mixins: [AdminContext],
  name: 'counter-field',
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Number,
      default: null,
    },
    maxValue: {
      type: Number,
      default: 10,
    },
    minValue: {
      type: Number,
      default: 0,
    },
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getErrors: function(field){
      return getValidationErrors({
        ...this.adminValidationMessages(defaultMessages),
        ...this.adminFieldValidationMessages(this.errorMessages),
      })(field)
    },
    increment() {
      this.validator && this.validator.$touch()
      const value = Math.min(this.maxValue, this.value + 1)
      this.$emit('input', value)
    },
    decrement() {
      this.validator && this.validator.$touch()
      const value = Math.max(this.minValue, this.value - 1)
      this.$emit('input', value)
    },
  },
}
</script>

<style scoped>

  .counter-value {
    height: 84px;
    font-size: 72px;
    font-weight: bold;
    line-height: 1.17;
  }

  .label {
    line-height: 20px;
    font-size: 16px;
    color: #979797;
  }


</style>
